import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import _ from 'lodash';
import UI from 'UI';
import eventify from 'Eventify';
import SMTeamLogo from '../SMTeamLogo';
import DateFormatted from '../DateFormatted';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const SkewContainer = styled.div``;

const StatsFormWrapper = styled.div`
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: ${props => props.theme.statTableBgColor};
    color: ${props => props.theme.statTableTextColor};
    padding: 18px 0 9px;

    > * {
        flex: 0 1 33.3%;
    }

    .title {
        font-size: 1.1875rem;
        color: ${props => props.theme.statTableLabelTextColor};
        text-align: center;
        min-width: 250px;
    }
`;

const MatchHeader = styled.div`
    padding: 20px 5px 20px;
    background-color: ${props => props.theme.content.backgroundColor};
    color: ${props => props.theme.color};
    display: flex;
    align-items: center;

    & > div {
        flex-grow: 1;
    }

    .name {
        .name-wrapper {
            display: inline-block;

            .team-name {
                display: inline-block;
            }
        }

        &.left {
            margin: 0 15px 0 0;

            .name-wrapper {
                transform: translateX(calc(50% - 20px));
            }

            > span {
                transform: translateX(calc(50% + 10px));
            }
        }

        &.right {
            margin: 0 0 0 15px;

            .name-wrapper {
                transform: translateX(calc(-50% + 20px));
            }

            > span {
                transform: translateX(calc(-50% - 10px));
            }
        }
    }

    .name-wrapper {
        display: inline-block;

        .team-name {
            display: inline-block;
        }

        &.left {
            margin: 0 15px 0 0;

            .team-name {
                background-color: green;
                transform: translateX(calc(50% - 20px));
            }
        }

        &.right {
            margin: 0 0 0 15px;

            .team-name {
                background-color: green;
                transform: translateX(calc(-50% + 20px));
            }
        }

        .rank-wrap {
            min-height: 21px;
        }
    }
`;

const MatchHeaderMin = MatchHeader.extend`
    display: block;

    .devider {
        font-size: 75px;
        line-height: 1em;
        font-weight: 900;
        transform: translateY(-13px);
        margin: 0 30px;
        color: ${props => props.theme.titleColor};
    }

    .teams-wrapper {
        display: flex;
        align-items: center;
    }

    .score-wrapper {
        > div {
            width: auto;
        }
    }
`;

//text-align: ${props => (props.side === 'home' ? 'right' : 'left')};

const Team = styled.div`
    text-align: center;
    flex: 0 1 33.3%;

    .wdp-team-logo {
        width: 60px;
        height: 60px;
        margin: 0;

        img {
            height: 100%;
            width: auto;
        }
    }

    .name {
        white-space: nowrap;
        & > * {
            vertical-align: middle;
        }
    }

    .team-name {
        padding: 0;
        font-size: 50px;
        line-height: 1em;
        font-weight: 900;
        color: ${props => props.theme.titleColor};
    }

    .rank {
        font-size: 1.125rem;
        display: block;
        text-transform: lowercase;
    }
`;

const StartInfo = styled.div`
    text-align: center;
    flex: 0 1 33.3%;

    .time {
        font-size: 38px;
        line-height: 40px;
        font-weight: 700;
        margin-top: 4px;
        margin-bottom: 4px;
    }

    .tournament {
        overflow: hidden;
        max-width: 130px;
        margin: 0 auto;
        text-transform: uppercase;
        font-size: 16px;
        line-height: 18px;
        font-weight: 700;

        svg {
            height: 13px;
            color: ${props => props.theme.color};
            fill: ${props => props.theme.color};
        }
    }

    .channel {
        font-size: 16px;
        line-height: 18px;
        white-space: nowrap;
    }
`;

const LiveLabel = styled.div`
    font-size: 1.125rem;
    line-height: 1em;
    font-weight: 700;
    margin-bottom: 3px;
    padding: 3px 10px;
    color: ${props => props.theme.subTitleColor};
    text-align: center;
    text-transform: uppercase;
    min-width: 90px;
    display: inline-block;
`;

const LiveLabelMin = LiveLabel.extend`
    font-size: 1.5rem;
    margin-bottom: 0;
    background: none;
`;

const FinishedLabel = LiveLabel.extend``;

const FinishedLabelMin = LiveLabelMin.extend``;

const Score = styled.div`
    font-size: 1.125rem;
    line-height: 1em;
    min-width: 250px;
    white-space: nowrap;
    text-align: center;
`;

const ScoreMin = Score.extend`
    width: 100%;
    font-size: 1.5rem;
    margin-bottom: 30px;
`;

const StatsForm = styled.ul`
    padding: 0;
    margin: 0;
    text-align: center;
`;

const StatItem = styled.li`
    background-color: ${props => props.theme.wdl[props.result]};
    display: inline-block;
    width: 16px;
    height: 16px;
    margin: 0 2px;
`;

const StatRows = styled.div``;

const StatRow = styled.div`
    display: flex;
    align-items: center;
    background-color: ${props => props.theme.statTableBgColor};
    padding: 8px 0;
    text-align: center;
    justify-content: space-around;

    > * {
        flex: 0 1 33.3%;
    }

    .val {
        min-width: 50px;
        font-size: 24px;
        line-height: 1em;
        font-weight: 700;
        color: ${props => props.theme.statTableTextColor};
    }

    .label {
        color: ${props => props.theme.statTableLabelTextColor};
        font-size: 18px;
        line-height: 1em;
        padding: 0 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        text-transform: uppercase;
    }

    .h2h_stats__chart {
        flex-grow: 1.5;
    }

    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tar {
        padding-right: 30px;

        .h2h_stats__val {
            width: auto;
        }
    }

    .h2h_stats__chart ~ .h2h_stats__val-wrapper.tal {
        padding-left: 30px;

        .h2h_stats__val {
            width: auto;
        }
    }
`;

const Chart = styled.div`
    width: 100%;
    height: 30px;
    position: relative;

    &:after {
        content: '';
        position: absolute;
        left: ${props => (props.dir === 'left' ? 0 : 'auto')};
        right: ${props => (props.dir === 'right' ? 0 : 'auto')};
        top: 0;
        bottom: 0;
        width: ${props => props.val}%;
        background-color: ${props => (props.color === 'home' ? props.theme.statColorHome : props.theme.statColorAway)};
    }
`;

const LatestH2HForm = styled.div`
    text-align: center;
    text-transform: uppercase;
    padding: 12px 30px 20px;
    color: ${props => props.theme.statTableTextColor};
    background-color: ${props => props.theme.statTableBgColor};

    .title {
        font-weight: 400;
        font-size: 0.825rem;
        margin-bottom: 5px;
        color: ${props => props.theme.statTableLabelTextColor};
    }

    .form {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: ${props => props.theme.statTableLabelTextColor};
    }
`;

const Cell = styled.div`
    height: 22px;
    line-height: 22px;
    flex-basis: ${props => props.flexBasis}%;
    white-space: nowrap;
    min-width: 74px;
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 0.875rem;
    font-weight: bold;
    transform: skew(-20deg);

    > span {
        transform: skew(20deg);
        display: inline-block;
    }

    &:nth-child(1) {
        color: ${props => props.theme.statTextColor};
        background-color: ${props => props.theme.statColorHome};
        text-align: left;
    }

    &:nth-child(2) {
        color: ${props => props.theme.statTextColor};
        background-color: ${props => props.theme.statColorNeutral || props.theme.content.statTableBgColor};
        padding: 0;
    }

    &:nth-last-of-type(1) {
        color: ${props => props.theme.statTextColor};
        background-color: ${props => props.theme.statColorAway};
        text-align: right;
    }
`;

const Header = ({ event, rankInfo }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');
    event = eventify(event);

    const { moment } = ctx;
    const { statusType, statusFull } = event;

    const isLive = statusType === 'inprogress';
    const isNotStarted = statusType === 'notstarted';
    const isFinished = statusFull === 'Finished';

    //ToDo: need to change in api
    const ttName =
        event.tournamentName.toLowerCase() === 'superliga' || event.tournamentName.toLowerCase() === 'superleague'
            ? `3F ${event.tournamentName}`
            : event.tournamentName;

    return (
        <MatchHeader>
            <Team side="home">
                <div className="name left">
                    <div className="name-wrapper">
                        <span className="team-name __c__c2_header_color_team_1">{event.homeShortName}</span>
                        {rankInfo &&
                            rankInfo.home && (
                                <span className="rank">
                                    <b>#{rankInfo.home.rank}</b> ({rankInfo.home.points} {i18('points', lang)})
                                </span>
                            )}
                    </div>
                    <SMTeamLogo tournamentId={event.tournamentTemplateId} teamId={event.homeId} />
                </div>
            </Team>

            {isNotStarted && (
                <StartInfo>
                    <div className="tournament">
                        <UI.TournamentName name={ttName} id={event.tournamentTemplateId} />
                    </div>
                    <DateFormatted className="time" el="div" date={event.startDate} type="TIME" />
                    {event.channel && <div className="channel">{event.channel.name}</div>}
                </StartInfo>
            )}

            {(isLive || isFinished) && (
                <Score>
                    {isLive && (
                        <LiveLabel>
                            {i18('live', lang)} {event.isHT() ? i18('ht', lang) : `${event.getMinutes()}'`}
                        </LiveLabel>
                    )}
                    {isFinished && <FinishedLabel>{i18('finished', lang)}</FinishedLabel>}
                    <div>
                        {_.get(event, 'score.home')}:{_.get(event, 'score.away')}
                    </div>
                </Score>
            )}

            <Team side="away">
                <div className="name right">
                    <SMTeamLogo tournamentId={event.tournamentTemplateId} teamId={event.awayId} />
                    <div className="name-wrapper">
                        <span className="team-name __c__c2_header_color_team_2">{event.awayShortName}</span>
                        {rankInfo &&
                            rankInfo.away && (
                                <span className="rank">
                                    <b>#{rankInfo.away.rank}</b> ({rankInfo.away.points} {i18('points', lang)})
                                </span>
                            )}
                    </div>
                </div>
            </Team>
        </MatchHeader>
    );
};

const HeaderMinimized = ({ event, rankInfo }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');
    event = eventify(event);

    const { moment } = ctx;
    const { statusType, statusFull } = event;

    const isLive = statusType === 'inprogress';
    const isNotStarted = statusType === 'notstarted';
    const isFinished = statusFull === 'Finished';

    return (
        <MatchHeaderMin>
            <div className="score-wrapper">
                {isNotStarted && (
                    <StartInfo>
                        <div className="tournament">
                            <UI.TournamentName name={event.tournamentName} id={event.tournamentTemplateId} />
                        </div>
                        <DateFormatted className="time" el="div" date={event.startDate} type="TIME" />
                        {event.channel && <div className="channel">{event.channel.name}</div>}
                    </StartInfo>
                )}

                {(isLive || isFinished) && (
                    <ScoreMin>
                        {isLive && (
                            <LiveLabelMin>
                                {i18('live', lang)} {event.isHT() ? i18('ht', lang) : `${event.getMinutes()}'`}
                            </LiveLabelMin>
                        )}
                        {isFinished && <FinishedLabelMin>{i18('finished', lang)}</FinishedLabelMin>}
                        <div>
                            {_.get(event, 'score.home')}:{_.get(event, 'score.away')}
                        </div>
                    </ScoreMin>
                )}
            </div>

            <div className="teams-wrapper">
                <Team side="home">
                    <div className="name">
                        <div className="name-wrapper left">
                            <span className="team-name __c__c1_header_color_team_1">{event.homeShortName}</span>
                            <div className="rank-wrap">
                                {rankInfo &&
                                    rankInfo.home && (
                                        <span className="rank">
                                            <b>#{rankInfo.home.rank}</b> ({rankInfo.home.points} {i18('points', lang)})
                                        </span>
                                    )}
                            </div>
                        </div>
                    </div>
                </Team>
                <span className="devider __c__c1_header_color_team_dash">-</span>
                <Team side="away">
                    <div className="name">
                        <div className="name-wrapper right">
                            <span className="team-name __c__c1_header_color_team_2">{event.awayShortName}</span>
                            <div className="rank-wrap">
                                {rankInfo &&
                                    rankInfo.away && (
                                        <span className="rank">
                                            <b>#{rankInfo.away.rank}</b> ({rankInfo.away.points} {i18('points', lang)})
                                        </span>
                                    )}
                            </div>
                        </div>
                    </div>
                </Team>
            </div>
        </MatchHeaderMin>
    );
};

const LatestFormRow = ({ form, limit, title, clean }, ctx) => {
    let latestHomeForm = form.home.short_results || [];
    let latestAwayForm = form.away.short_results || [];

    const latestHomeFormCount = latestHomeForm.length;
    const latestAwayFormCount = latestAwayForm.length;

    const notPlayedHomeGames =
        latestHomeFormCount < limit ? new Array(limit - latestHomeFormCount).fill({ result: 'notPlayed' }) : null;
    const notPlayedAwayGames =
        latestAwayFormCount < limit ? new Array(limit - latestAwayFormCount).fill({ result: 'notPlayed' }) : null;

    if (notPlayedHomeGames) latestHomeForm = [...notPlayedHomeGames, ...latestHomeForm];
    if (notPlayedAwayGames) latestAwayForm = [...notPlayedAwayGames, ...latestAwayForm];

    return (
        <StatsFormWrapper>
            <StatsForm>
                {latestHomeForm.map((r, i) => {
                    return <StatItem key={i} result={r.result} className={`stat-item_${r.result}`} />;
                })}
            </StatsForm>

            <span className="title __c__c1_style1">
                {title} {latestHomeFormCount}
            </span>

            <StatsForm>
                {latestAwayForm.map((r, i) => {
                    return <StatItem key={i} result={r.result} className={`stat-item_${r.result}`} />;
                })}
            </StatsForm>
        </StatsFormWrapper>
    );
};

const Rows = ({ dataset }) => {
    return (
        <StatRows>
            {dataset.map((row, i) => {
                let {
                    label,
                    home,
                    away,
                    postfix = '',
                    prefix = '',
                    sum,
                    chart = true,
                    lessIsBetter = false,
                    toFixed = false,
                    displayChart = false,
                } = row;

                if (!sum) sum = home + away;
                let homeIsBetter = home > away;
                let awayIsBetter = away > home;

                if (lessIsBetter) homeIsBetter = !homeIsBetter;
                if (lessIsBetter) awayIsBetter = !awayIsBetter;

                return (
                    <StatRow key={i}>
                        {displayChart && (
                            <div className="h2h_stats__chart">
                                {chart && <Chart val={(home / sum) * 100} dir="left" color="home" />}
                            </div>
                        )}

                        {home != null && (
                            <div className="val __c__c4_style1">
                                {prefix}
                                {Number.isInteger(home) ? home : home.toFixed(toFixed)}
                                {postfix}
                            </div>
                        )}

                        <div className="label __c__c2_style1">{label}</div>

                        {away != null && (
                            <div className="val __c__c3_style1">
                                {prefix}
                                {Number.isInteger(away) ? away : away.toFixed(toFixed)}
                                {postfix}
                            </div>
                        )}

                        {displayChart && (
                            <div className="tar h2h_stats__chart">
                                {chart && <Chart val={(away / sum) * 100} dir="right" color="away" />}
                            </div>
                        )}
                    </StatRow>
                );
            })}
        </StatRows>
    );
};

const H2HRow = ({ event, h2h, h2hTitle }) => {
    if (!h2h.homeTeam) return <div />;
    const cells = [
        {
            name: event.homeShortName,
            value: h2h.homeTeam.wins,
        },
        {
            name: h2hTitle.draw,
            value: h2h.draws,
        },
        {
            name: event.awayShortName,
            value: h2h.awayTeam.wins,
        },
    ];

    const numOfMatches = h2h.homeTeam.wins + h2h.draws + h2h.awayTeam.wins;

    return (
        <LatestH2HForm>
            <div className="title __c__c5_style1">
                {numOfMatches} {h2hTitle.title}
            </div>
            <div className="form">
                {cells.map((v, i) => (
                    <Cell key={i} flexBasis={v.value * (100 / numOfMatches)} className={`__c__b${i}_style1`}>
                        <span className="__c__c7_style1">
                            {v.name}: {v.value}
                        </span>
                    </Cell>
                ))}
            </div>
        </LatestH2HForm>
    );
};

Header.contextTypes = {
    info: PropTypes.object,
    moment: PropTypes.func,
};

HeaderMinimized.contextTypes = {
    info: PropTypes.object,
    moment: PropTypes.func,
};

LatestFormRow.contextTypes = {
    info: PropTypes.object,
    moment: PropTypes.func,
};

Rows.contextTypes = {
    info: PropTypes.object,
    moment: PropTypes.func,
};

H2HRow.contextTypes = {
    info: PropTypes.object,
    moment: PropTypes.func,
};

const Container = ({ children }) => <SkewContainer>{children}</SkewContainer>;

export default { Container, Header, HeaderMinimized, LatestFormRow, Rows, H2HRow };
export { Container, Header, HeaderMinimized, LatestFormRow, Rows, H2HRow };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/h2h/H2HTableSkew.js
 **/